import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { NoEsSoloEbook } from '../components/NoEsSoloEbook';
import { SobrePaola } from '../components/SobrePaola';
import { QueHaceDiferente } from '../components/QueHaceDiferente';
import { ParaQuienEs } from '../components/ParaQuienEs';
import { Pilares } from '../components/Pilares';
import { VistaPorDentro } from '../components/VistaPorDentro';
import { QueIncluye } from '../components/QueIncluye';
import { BundleOffer } from '../components/BundleOffer';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="min-h-screen bg-background" data-id="element-305">
      <Hero data-id="element-306" />
      <NoEsSoloEbook data-id="element-307" />
      <SobrePaola data-id="element-308" />
      <QueHaceDiferente data-id="element-309" />
      <ParaQuienEs data-id="element-310" />
      <Pilares data-id="element-311" />
      <VistaPorDentro data-id="element-312" />
      <QueIncluye data-id="element-313" />
      <BundleOffer data-id="element-314" />
      <FAQ data-id="element-315" />
      <Footer data-id="element-316" />
    </main>;
}